import {ConfigurableChartDemoContainer} from "./ConfigurableChartDemo.elements";
import { generateDemoData } from "../util/generateDemoData";
 
import { useRouterWithHandler } from "common/hooks";
import { StatelessForm } from "common/components/StatelessForm/v2";
import { DataTable } from "common/ui/DataTables";
 import { DataObjectDisplay } from "common/ui/DataTables/DataObjectDisplay";
import { useMemo, useRef } from "react";
 
import { ConfigurableChart } from "../ConfigurableChart";
import * as  dsi_demo_data  from './demoData3'
import useContainerSize from "common/hooks/useContainerSize";
 
 

 

// this is the normal one
export const ConfigurableLineChartDemo1 = (): JSX.Element => {
  
  const [{  
    data_type = 'inline-item', 
    chart_type = 'line' 
  }, go] = useRouterWithHandler('charts_demo/data_type/chart_type')

  const {
    data,
    grouping_key, 
    timestamp_key,
    totals_key,
    time_interval,
    count_key,
    start_time,
    end_time    
 } = useMemo(() => generateDemoData({
    groups: ['chicken'],
    totals_key: 'weight', 
    grouping_key: 'recipe',
    //count_key: 'count',
    interval: '30 minutes',
    days: 15
  }) || {}, [])
  

  const chart_settings = {
    chart_type: 'line',
    data,
    timestamp_key,
    start_time, 
    end_time,
    color: 'pink',
    data_type: 'inline',
    axis_settings: {
      left: {
        scale_type: 'linear',
        key: totals_key
      },
      bottom: {
        scale_type: 'time',
        key: timestamp_key,
        tick_count: 10
      }
    }
  }
 
  return (
    <ConfigurableChartDemoContainer>
      <h2 className='full'>Chart Demos</h2>
      <div className='col-l'>
        <div className='padding'>
          <div><strong>Chart Settings</strong></div>
           Line Chart 
        </div>
      </div>
      <div className='col-r'>
        <div className='padding'>
          <ConfigurableChart {...chart_settings} />
        </div>
      </div>
      <div className='data-area'>
        <div className='padding data-settings'>
          <div><strong>Demo Data Type</strong></div>
          <StatelessForm {...{
            className:'inline-form hide-submit hide-cancel',
            handleSelect: (x) => {
              go('updatePath', x)
            },
            formFields: [{
              name: 'data_type',
              label: 'Data Type',
              type: 'select',
              options: ['inline-item'],
              defaultValue: data_type
            }]
          }}/>
          <div><strong>Data Settings</strong></div>
          <DataObjectDisplay {...{
            grouping_key,
    timestamp_key,
    totals_key,
    time_interval,
    count_key,
    start_time,
    end_time  
          }} />
        </div>
        <div className='padding'>
          <div><strong>Data Sample</strong></div>
          <DataTable data={data.slice(0,10)  } />
        </div>
      </div>
    </ConfigurableChartDemoContainer>
  )
}
 
 
 

 


export const ConfigurableLineChartDemo = (): JSX.Element => {
  
  const [{  
    data_type = 'inline-item', 
    chart_type = 'line' 
  }, go] = useRouterWithHandler('charts_demo/data_type/chart_type')

  const {
 
    grouping_key, 
    timestamp_key,
    value_key,
    start_time = dsi_demo_data?.utc_start_datetime,
    end_time = dsi_demo_data?.utc_end_datetime    
  } =  dsi_demo_data as unknown as Record<string, unknown>
  
  const data = dsi_demo_data?.data() as Record<string, unknown>[]

  const chart_settings = {
    chart_type: 'line',
    data,
    timestamp_key,
    start_time, 
    end_time,
    color: 'pink',
    data_type: 'inline',
    axis_settings: {
      left: {
        scale_type: 'linear',
        key: value_key
      },
      bottom: {
        scale_type: 'time',
        key: timestamp_key,
      }
    }
  }

  const clean_inline_time_data = (timestamp_key: string, props?: Record<string, unknown>) => {
    
    const {
      // if the prev and next items do not contain the current group, remove the item
      remove_single_group_items = true,
      grouping_key,
      data
    } = props || {}
    if (!data) return [[], []] as [Record<string, unknown>[], number[]]

    const cleaned_data = [] as Record<string, unknown>[]
    const timestamps = new Set()
    const groups = new Set()

    const intervals = {}
    let predicted_interval = 0

    for (let i = 1; i < data.length - 1; i++) {
      const item = data[i] || {}
      let keep = true
      let timestamp = (item?.[timestamp_key] || '') as string | number
      const group = item?.[grouping_key as string || '']

      if (timestamp) timestamp = new Date(timestamp).getTime()
      
      timestamps.add(timestamp)
      groups.add(group)

      const prev_item = data[i - 1] || {}
      const next_item = data[i + 1] || {}

      const int = new Date(next_item?.[timestamp_key] || '').getTime() as number - timestamp as number
      const is_single_group = prev_item?.[grouping_key] !== group && next_item?.[grouping_key] !== group

      if (!intervals[int]) intervals[int] = 0
      intervals[int] += 1

      if (remove_single_group_items && is_single_group) keep = false
      if (keep) cleaned_data.push(item)
     
    }

    // get the most common interval and use it as the predicted interval for future data points
    const interval_counts = Object.entries(intervals).sort((a, b) => (b[1] as number) - (a[1] as number))
    if (interval_counts?.length) predicted_interval = parseInt(interval_counts[0][0])
   
    return [
      cleaned_data, 
      Array.from(timestamps).sort(), 
      Array.from(groups),
      predicted_interval
    ] as [
      Record<string, unknown>[], 
      number[], 
      string[],
      number
    ]
  }
  
  const [
    cleaned_data, 
    timestamps, 
    groups,
    interval
  ] = clean_inline_time_data(timestamp_key as string, { grouping_key: grouping_key, data: data as Record<string, unknown>[] })

  
  
  const normal_data = Array.from(timestamps).map((t) => {
    return {
      [timestamp_key]: t,
    }
  })
  
  const chart_ref = useRef(null) as RefObject<HTMLDivElement>
  console.log({chart_ref})
  chart_settings.chart_ref = chart_ref

  console.log({width, height})
  return (
    <ConfigurableChartDemoContainer>
      <h2 className='full'>Chart Demos</h2>
      <div className='col-l'>
        <div className='padding'>
          <div><strong>Chart Settings</strong></div>
           Line Chart 
        </div>
      </div>
      <div className='col-r'>
        <div className='padding'>
          <ConfigurableChart {...chart_settings} />
        </div>
      </div>
      <div className='data-area'>
        <div className='padding data-settings'>
          <div><strong>Demo Data Type</strong></div>
          <StatelessForm {...{
            className:'inline-form hide-submit hide-cancel',
            handleSelect: (x) => {
              go('updatePath', x)
            },
            formFields: [{
              name: 'data_type',
              label: 'Data Type',
              type: 'select',
              options: ['inline-item'],
              defaultValue: data_type
            }]
          }}/>
          <div><strong>Data Settings</strong></div>
          <DataObjectDisplay {...{
            grouping_key,
    timestamp_key,
    value_key,
    start_time,
    end_time  
          }} />
        </div>
        <div className='padding'>
          <div><strong>Data Sample</strong></div>
          <DataTable data={data.slice(0,10)  } />
        </div>
      </div>
    </ConfigurableChartDemoContainer>
  )
}